import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const SessionsLayout = lazy(() => import('@/pages/sessions/layout'));
const SessionsListPage = lazy(() => import('@/pages/sessions'));

/**
 * UG-4500 — session routes (legacy `app/(dashboard)/sessions/page.tsx`).
 * List-only: the diagnostics detail is a dialog on the grid row (no
 * `getById` route in reipm-api). Permission: `/sessions` in
 * `@/config/auth/routeAccess`. `SessionsLayout` mounts the section
 * breadcrumb (UG-4513).
 */
export const sessionRoutes: RouteConfig = {
  path: '/sessions',
  layout: DashboardLayout,
  children: [{ path: '', layout: SessionsLayout, element: SessionsListPage }],
};
